//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CuttingBed',
  props: {
    mesCuttingBedSizeVo: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {};
  }
};